var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 80",
    style: {
      enableBackground: "new 0 0 64 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M54.2,24.4l-12-12.5c-1.1-1.1-2.6-1.8-4.2-1.8H10.1c-1,0-1.8,0.7-1.8,1.7V68c0,1,0.9,1.7,1.8,1.7h43.8 c1,0,1.8-0.7,1.8-1.7V28C55.7,26.7,55.1,25.4,54.2,24.4z M49.3,26h-8.1c-0.3,0-0.6-0.2-0.6-0.6l0,0v-8.5c0-0.3,0.3-0.6,0.6-0.6 c0.2,0,0.3,0.1,0.4,0.2l8.1,8.5c0.2,0.2,0.2,0.6,0,0.8C49.6,25.9,49.5,26,49.3,26z M51,66.3H13c-0.5,0-1-0.4-1-1V14.6 c0-0.5,0.5-1,1-0.9h22.8c0.5,0,1,0.4,1,0.9v13.5c0,0.8,0.6,1.3,1.4,1.3l0,0h12c1,0,1.8,0.7,1.8,1.7l0,0v34.2 C52,65.9,51.5,66.3,51,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,42.2H18.3c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8h27.4c1,0,1.8,0.8,1.8,1.8 C47.4,41.4,46.6,42.2,45.7,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,49.8H18.3c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8h27.4c1,0,1.8,0.8,1.8,1.8S46.6,49.8,45.7,49.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45.7,57.3H18.3c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8h27.4c1,0,1.8,0.8,1.8,1.8S46.6,57.3,45.7,57.3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.9025cf6cf1edd5c5ea4edc1540f4b324.svg";
export { ForwardRef as ReactComponent };